import {Directive, ElementRef, Input, OnInit} from '@angular/core';

@Directive({
  selector: '[linaDisableAll]'
})
export class DisableAllDirective implements OnInit {
  _disableAll: boolean;
  @Input() set linaDisableAll(disableAll: boolean) {
    this._disableAll = disableAll;
    this.evaluateDisable();
  }

  get linaDisableAll(): boolean {
    return this._disableAll;
  }

  constructor(private element: ElementRef) {
  }

  ngOnInit() {
  }

  evaluateDisable() {
    if (this.linaDisableAll) {
      this.disableAll();
    } else {
      this.enableAll();
    }
  }

  disableAll() {
    this.disableElements(document.getElementsByTagName('button'));
    this.disableElements(document.getElementsByTagName('input'));
    this.disableElements(document.getElementsByTagName('textarea'));
    this.disableElements(document.getElementsByTagName('select'));
  }

  enableAll() {
    this.enableElements(document.getElementsByTagName('button'));
    this.enableElements(document.getElementsByTagName('input'));
    this.enableElements(document.getElementsByTagName('textarea'));
    this.enableElements(document.getElementsByTagName('select'));
  }

  disableElements(elements) {
    const len = elements.length;
    for (let i = 0; i < len; i++) {
      if (elements[i].disabled === false) {
        elements[i].disabled = true;
        elements[i].disabledIf = true;
      }
    }
  }


  enableElements(elements) {
    const len = elements.length;
    for (let i = 0; i < len; i++) {
      if (elements[i].disabled === true && elements[i].disabledIf === true) {
        elements[i].disabled = false;
        elements[i].disabledIf = null;
      }
    }
  }

  preventDefaultListener(event) {
    event.stopPropagation();
    event.preventDefault();
    return false;
  }

}
